import { SVGProps, Ref, forwardRef } from 'react';

export const LiferingFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M15.5 8c0 1.805-.434 3.61-1.513 4.997L11.13 10.14c.377-.628.534-1.385.534-2.142s-.157-1.514-.534-2.142L13.985 3c1.08 1.388 1.515 3.194 1.515 5"
                    fill="currentColor"
                />
                <path
                    d="M10.146 4.86 13 2.005C11.836 1.077 10.206.5 8 .5c-2.208 0-3.838.578-5.004 1.506L5.85 4.86c.54-.33 1.245-.528 2.148-.528s1.608.198 2.148.528"
                    fill="currentColor"
                />
                <path
                    d="M4.866 5.856 2.013 3.003C.935 4.389.5 6.195.5 8s.434 3.608 1.51 4.995l2.856-2.855c-.377-.628-.534-1.385-.534-2.142s.157-1.514.534-2.142"
                    fill="currentColor"
                />
                <path
                    d="M10.146 11.136c-.54.33-1.245.528-2.148.528s-1.608-.198-2.148-.528l-2.856 2.856C4.16 14.922 5.791 15.5 8 15.5s3.838-.578 5.004-1.506z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
LiferingFilledSize16Glyph.displayName = 'LiferingFilledSize16Glyph';
